<div class="user-header">
  <glxy-avatar
    class="avatar"
    [src]="profilePictureUrl()"
    [name]="displayName()"
    [width]="large() ? 32 : 18"
    [shape]="shape()"
  ></glxy-avatar>
  <div class="user-name">
    @if (linkToContactPage()) {
      <a [routerLink]="profileUrl$ | async">
        {{ displayName() }}
      </a>
    } @else {
      {{ displayName() }}
    }
    @if (suffix()) {
      <span class="suffix">{{ suffix() }}</span>
    }
  </div>
</div>
